// Link.js
import React from 'react';
import PropTypes from 'prop-types';

const Link = ({ text, href, tstyle='' }) => {
  return (
    <a 
      href={href} 
      className={`font-semibold text-sm md:text-base lg:text-lg transition-all duration-300 transform hover:text-emerald-500 cursor-pointer ${tstyle}`}
    >
      {text}
    </a>
  );
};

Link.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  tstyle: PropTypes.string,
};

export default Link;
